import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'tripStatusCd' })
export class TripStatusCdPipe implements PipeTransform {
  transform(value: string, args?: any): string {
    switch ((value || '').toUpperCase()) {
      case 'NEW':
        return 'New';
      case 'COMP':
        return 'Complete';
      case 'DISP':
        return 'Dispatched';
      case 'RTN':
        return 'Returning';
    }

    return value;
  }
}
